import { composeQuery, getRootCollection } from './queries'
import { doc } from './common'
import { getUserId } from './users'

const listFeatureToggles = () => getRootCollection('featureToggles')

const GLOBAL_FEATURE_TOGGLES_ID = 'default'

export const getGlobalFeatureToggleSet = () =>
  composeQuery(listFeatureToggles, doc(GLOBAL_FEATURE_TOGGLES_ID))

export const getUserFeatureToggleSet = (user) =>
  composeQuery(listFeatureToggles, doc(getUserId(user)))
